export default function Footer() {
    return (<div className="p-2 text-center text-white bg-black">
        &copy; {new Date().getFullYear()} <a href="https://github.com/LouisvilleData">LouisvilleData</a>
    </div>)
}